module.exports = __webpack_public_path__ + "static/img/phone.8153a1f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/phone.png
// module id = VRKa
// module chunks = 73